import { Column } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui'
import { ArrowLeft } from 'lucide-react'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const ProductNotFound = () => {
  const { t } = useLocalization()

  return (
    <div className="w-full min-h-dvh flex items-center justify-center p-4">
      <Column className="items-center gap-4">
        <h2 className="text-2xl font-semibold">
          {t('Product not found', 'Produkt hittades inte')}
        </h2>
        <Button onClick={() => window.history.back()}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('Back to products', 'Tillbaka till produkter')}
        </Button>
      </Column>
    </div>
  )
}

